import { buildRoute } from '@direct-frontend/modules-router';

export const clientsRoute = buildRoute('/clients');
export const clientsImportExcelRoute = buildRoute('/clients/import/excel');
